import actions from './actions';

const initState = {
    productGroupInfo : {},
    productGroups   : {
        data: []
    },
    loading : false,
    productGroupDeleted : false
};

export default function fetchProductGroupsReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_PRODUCT_GROUPS_REQUESTED:
            return {
                ...state,
                productGroups   : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_PRODUCT_GROUPS_SUCCEEDED:
            return {
                ...state,
                productGroups    : action.productGroups,
                loading     : false
            };
        case actions.FETCH_PRODUCT_GROUPS_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.FETCH_PRODUCT_GROUP_REQUESTED:
            return {
                ...state,
                productGroupInfo : {},
                loading : true
            };
        case actions.FETCH_PRODUCT_GROUP_SUCCEEDED:
            return {
                ...state,
                productGroupInfo: action.productGroup,
                loading     : false
            };
        case actions.FETCH_PRODUCT_GROUP_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.DELETE_PRODUCT_GROUP_REQUESTED:
            return {
                ...state,
                productGroupDeleted : false,
                loading : true
            };
        case actions.DELETE_PRODUCT_GROUP_SUCCEEDED:
            return {
                ...state,
                productGroupDeleted: true,
                loading: false
            };
        case actions.DELETE_PRODUCT_GROUP_FAILED:
            return {
                ...state,
                loading : false
            };
        default:
            return state;
    }
}
